// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IYt4x","productName":"Table_productName__3BnEb"};